function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { isCollapsed, queryNode } from '@udecode/plate-common';
import { getPlatePluginWithOverrides } from '@udecode/plate-core';
import { Editor, Transforms } from 'slate';

/**
 * Set a list of element types to select on backspace
 */
var withSelectOnBackspace = function withSelectOnBackspace(query) {
  return function (editor) {
    var deleteBackward = editor.deleteBackward;
    editor.deleteBackward = function (unit) {
      var selection = editor.selection;
      if (unit === 'character' && isCollapsed(selection)) {
        var prevNode = Editor.before(editor, selection, {
          unit: unit
        });
        if (prevNode) {
          var _Editor$nodes = Editor.nodes(editor, {
              match: function match(node) {
                return queryNode([node, prevNode.path], query);
              },
              at: prevNode
            }),
            _Editor$nodes2 = _slicedToArray(_Editor$nodes, 1),
            prevCell = _Editor$nodes2[0];
          if (!!prevCell && prevNode) {
            // don't delete image, set selection there
            Transforms.select(editor, prevNode);
          } else {
            deleteBackward(unit);
          }
        } else {
          deleteBackward(unit);
        }
      } else {
        deleteBackward(unit);
      }
    };
    return editor;
  };
};
/**
 * @see {@link withSelectOnBackspace}
 */

var createSelectOnBackspacePlugin = getPlatePluginWithOverrides(withSelectOnBackspace);
export { createSelectOnBackspacePlugin, withSelectOnBackspace };